function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.96 10.58l6.28-6.28c.4-.4 1.06-.4 1.46 0 .4.4.4 1.06 0 1.46l-6.28 6.28 6.28 6.19c.4.4.4 1.06 0 1.46-.4.4-1.06.4-1.46 0l-6.28-6.19-6.2 6.2c-.4.4-1.06.4-1.46 0-.4-.4-.4-1.06 0-1.46l6.19-6.19L4.3 5.76c-.4-.4-.4-1.06 0-1.46.4-.4 1.06-.4 1.46 0l6.2 6.28z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}));